import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailLayoutComponent } from './detail-layout.component';

@NgModule({
  declarations: [DetailLayoutComponent],
  exports: [DetailLayoutComponent],
  imports: [CommonModule]
})
export class DetailLayoutModule {}
